import React from 'react';
import { useTranslation } from 'react-i18next';

import { LegacyFieldReadMode } from '~/legacy-components/LegacyForms';

import { EmpOffContactType, Office } from '../../data';

type Props = {
  data: EmpOffContactType;
  companyOffice: Office[];
};

export const WorkContactReadMode = ({ data: emp, companyOffice }: Props) => {
  const { t } = useTranslation();

  const officeLocation = companyOffice.find(
    (country) => country.fOfficeId === emp.fEmpOfficeLoc,
  );

  return (
    <>
      <LegacyFieldReadMode
        label={t('fEmpPhoneWork')}
        value={emp?.fEmpPhoneWork}
      />
      <LegacyFieldReadMode
        label={t('fEmpPhoneMob')}
        value={emp?.fEmpPhoneMob}
      />
      <LegacyFieldReadMode
        label={t('fEmpEmailHome')}
        value={emp?.fEmpEmailWork}
      />
      <LegacyFieldReadMode
        label={t('fEmpOfficeLoc')}
        value={officeLocation?.fOfficeCity}
      />
      <LegacyFieldReadMode
        label={t('fEmpOfficeFloor')}
        value={emp?.fEmpOfficeFloor}
      />
      <LegacyFieldReadMode
        label={t('fEmpOfficeRoom')}
        value={emp?.fEmpOfficeRoom}
      />
    </>
  );
};
